"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BootstrapModal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Modal = _interopRequireDefault(require("react-bootstrap/lib/Modal"));
var _classnames = _interopRequireDefault(require("classnames"));
var _get = _interopRequireDefault(require("lodash/get"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var BootstrapModal = exports.BootstrapModal = /*#__PURE__*/function (_Component) {
  _inherits(BootstrapModal, _Component);
  function BootstrapModal(props) {
    var _this;
    _classCallCheck(this, BootstrapModal);
    _this = _callSuper(this, BootstrapModal, [props]);
    _this.closeModal = _this.closeModal.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(BootstrapModal, [{
    key: "closeModal",
    value: function closeModal(event) {
      event.stopPropagation();
      if (this.props.onClose) {
        return this.props.onClose(event);
      }
      return this.props.toggleModal('');
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        _this$props$banner = _this$props.banner,
        banner = _this$props$banner === void 0 ? {} : _this$props$banner,
        _this$props$addCloseI = _this$props.addCloseIcon,
        addCloseIcon = _this$props$addCloseI === void 0 ? true : _this$props$addCloseI,
        title = _this$props.title,
        header = _this$props.header,
        footer = _this$props.footer,
        body = _this$props.body,
        _this$props$bannerCla = _this$props.bannerClass,
        bannerClass = _this$props$bannerCla === void 0 ? '' : _this$props$bannerCla,
        _this$props$bannerOve = _this$props.bannerOverrideClasses,
        bannerOverrideClasses = _this$props$bannerOve === void 0 ? '' : _this$props$bannerOve,
        _this$props$titleClas = _this$props.titleClass,
        titleClass = _this$props$titleClas === void 0 ? '' : _this$props$titleClas,
        _this$props$headerCla = _this$props.headerClass,
        headerClass = _this$props$headerCla === void 0 ? '' : _this$props$headerCla,
        _this$props$subheader = _this$props.subheaderClass,
        subheaderClass = _this$props$subheader === void 0 ? '' : _this$props$subheader,
        _this$props$bodyClass = _this$props.bodyClass,
        bodyClass = _this$props$bodyClass === void 0 ? '' : _this$props$bodyClass,
        _this$props$footerCla = _this$props.footerClass,
        footerClass = _this$props$footerCla === void 0 ? '' : _this$props$footerCla,
        _this$props$modalClas = _this$props.modalClass,
        modalClass = _this$props$modalClas === void 0 ? '' : _this$props$modalClas,
        _this$props$modalSize = _this$props.modalSize,
        modalSize = _this$props$modalSize === void 0 ? 'sm-size' : _this$props$modalSize,
        showModal = _this$props.showModal,
        subheader = _this$props.subheader,
        goBack = _this$props.goBack,
        _this$props$fixedHead = _this$props.fixedHeaderFooter,
        fixedHeaderFooter = _this$props$fixedHead === void 0 ? false : _this$props$fixedHead,
        _this$props$fixedTitl = _this$props.fixedTitleFooter,
        fixedTitleFooter = _this$props$fixedTitl === void 0 ? false : _this$props$fixedTitl,
        _this$props$stickyFoo = _this$props.stickyFooter,
        stickyFooter = _this$props$stickyFoo === void 0 ? false : _this$props$stickyFoo;
      var bannerTypeClass = (0, _get.default)(banner, 'type', '');
      var bannerChildClass = (0, _get.default)(banner, 'childClass', '');
      var bannerClassName = (0, _classnames.default)('modal-banner text-center', bannerClass, bannerTypeClass);
      var bannerOverrideClassName = (0, _classnames.default)(bannerOverrideClasses);
      var dialogClassName = (0, _classnames.default)('BootstrapModal modal-dialogue', modalSize, modalClass);
      var titleClassName = (0, _classnames.default)('flex space-between middle', titleClass, {
        'border-bottom modal-fixed-header-footer': fixedTitleFooter
      });
      var headerClassName = (0, _classnames.default)('modal-header', headerClass, {
        'text-center': !fixedHeaderFooter,
        'text-left border-bottom modal-fixed-header-footer': fixedHeaderFooter
      });
      var bodyClassName = (0, _classnames.default)('modal-body', bodyClass, {
        'modal-fixed-header-footer': fixedHeaderFooter
      });
      var footerClassName = (0, _classnames.default)('modal-footer', stickyFooter && 'modal-sticky-footer', footerClass, {
        'modal-fixed-header-footer border-top': fixedHeaderFooter
      });
      if (!showModal) return null;
      return /*#__PURE__*/_react.default.createElement(_Modal.default, {
        enforceFocus: false,
        show: showModal,
        backdrop: "static",
        dialogClassName: dialogClassName,
        backdropClassName: "bs-backdrop",
        animation: false
      }, !(0, _isEmpty.default)(banner) && /*#__PURE__*/_react.default.createElement("div", {
        "data-testing-id": "banner-wrapper",
        className: bannerOverrideClassName.length ? bannerOverrideClassName : bannerClassName
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: bannerChildClass
      }, banner.text)), /*#__PURE__*/_react.default.createElement("div", {
        className: titleClassName,
        style: {
          paddingTop: '8px',
          paddingBottom: '8px'
        }
      }, goBack && /*#__PURE__*/_react.default.createElement("button", {
        "data-testing-id": "back-btn",
        className: "btn btn-link remove-click-styling ico ico-md icon-back",
        onClick: goBack
      }), title && /*#__PURE__*/_react.default.createElement("div", {
        className: "margin-lg-left margin-lg-right"
      }, title), addCloseIcon && /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link remove-click-styling ico ico-sm icon-close-sidebar",
        onClick: this.closeModal
      })), header && /*#__PURE__*/_react.default.createElement(_Modal.default.Header, {
        bsClass: headerClassName
      }, header, subheader && /*#__PURE__*/_react.default.createElement("p", {
        className: subheaderClass
      }, subheader)), /*#__PURE__*/_react.default.createElement(_Modal.default.Body, {
        bsClass: bodyClassName
      }, body), footer && /*#__PURE__*/_react.default.createElement(_Modal.default.Footer, {
        bsClass: footerClassName
      }, footer));
    }
  }]);
  return BootstrapModal;
}(_react.Component);
BootstrapModal.propTypes = {
  banner: _propTypes.default.object,
  addCloseIcon: _propTypes.default.bool,
  header: _propTypes.default.object,
  footer: _propTypes.default.object,
  body: _propTypes.default.object,
  bannerClass: _propTypes.default.string,
  modalClass: _propTypes.default.string,
  bodyClass: _propTypes.default.string,
  footerClass: _propTypes.default.string,
  modalSize: _propTypes.default.string,
  showModal: _propTypes.default.bool,
  toggleModal: _propTypes.default.func,
  onClose: _propTypes.default.func,
  enforceFocus: _propTypes.default.bool,
  subheader: _propTypes.default.string,
  goBack: _propTypes.default.func,
  fixedHeaderFooter: _propTypes.default.bool,
  headerClass: _propTypes.default.string,
  subheaderClass: _propTypes.default.string,
  bannerOverrideClasses: _propTypes.default.string
};
var _default = exports.default = BootstrapModal;